import { SnippetsOutlined, UserOutlined, ProfileOutlined, AccountBookOutlined, FolderOpenOutlined, DatabaseOutlined, QuestionCircleOutlined, UsergroupAddOutlined, BoldOutlined } from '@ant-design/icons';
import Dashboard from './pages/Dashboard';
import Users from './pages/Users';
import UserAccount from './pages/Accounts/AccountsDetails';
import Logs from './pages/Logs';
import ScriptResults from './pages/ScriptResults';
import MongoQueries from './pages/MongoQueries';
import Accounts from './pages/Accounts';
import BigQueries from './pages/BigQueries';
import Tasks from './pages/Tasks';

export default {

    "dashboard": {
        key: "dashboard",
        path: "/admin",
        name: "Admin Home",
        icon: SnippetsOutlined,
        component: Dashboard
    },

    "users": {
        key: "users",
        path: "/admin/users",
        name: "Users",
        icon: UserOutlined,
        component: Users
    },

    "user": {
        hideInNav: true,
        key: "users",
        path: "/admin/users/:searchId",
        name: "User",
        icon: UserOutlined,
        component: Users
    },

    "accounts": {
        key: "accounts",
        path: "/admin/accounts",
        name: "Accounts",
        icon: UsergroupAddOutlined,
        component: Accounts
    },

    "account": {
        hideInNav: true,
        key: "accounts",
        path: "/admin/accounts/:searchId",
        name: "User Account",
        icon: AccountBookOutlined,
        component: Accounts
    },

    "Account": {
        hideInNav: true,
        key: "accounts",
        path: "/admin/accounts/account/:searchId",
        name: "Accounts",
        icon: UsergroupAddOutlined,
        component: UserAccount
    },

    "logs": {
        key: "logs",
        path: "/admin/logs",
        name: "Logs",
        icon: ProfileOutlined,
        component: Logs
    },

    "log": {
        hideInNav: true,
        key: "logs",
        path: "/admin/logs/:searchId",
        name: "Log",
        icon: ProfileOutlined,
        component: Logs
    },

    "ScriptResults": {
        key: "script-results",
        path: "/admin/script-results",
        name: "Script Results",
        icon: DatabaseOutlined,
        component: ScriptResults
    },

    "ScriptResult": {
        hideInNav: true,
        key: "script-results",
        path: "/admin/script-results/:searchId",
        name: "Script Result",
        icon: DatabaseOutlined,
        component: ScriptResults
    },

    "MongoQueries": {
        key: "mongo-queries",
        path: "/admin/mongo-queries",
        name: "Mongo Queries",
        icon: QuestionCircleOutlined,
        component: MongoQueries
    },

    "MongoQuery": {
        hideInNav: true,
        key: "mongo-queries",
        path: "/admin/mongo-queries/:searchId",
        name: "Mongo Query",
        icon: DatabaseOutlined,
        component: MongoQueries
    },

    "BigQueries": {
        key: "bigquery-queries",
        path: "/admin/bigquery-queries",
        name: "Big Queries",
        icon: BoldOutlined,
        component: BigQueries
    },

    "BigQuery": {
        hideInNav: true,
        key: "bigquery-queries",
        path: "/admin/bigquery-queries/:searchId",
        name: "Big Query",
        icon: BoldOutlined,
        component: BigQueries
    },

    "Tasks": {
        key: "tasks",
        path: "/admin/tasks",
        name: "Tasks",
        icon: FolderOpenOutlined,
        component: Tasks
    },

    "Task": {
        hideInNav: true,
        key: "tasks",
        path: "/admin/tasks/:searchId",
        name: "Big Query",
        icon: FolderOpenOutlined,
        component: Tasks
    },

}
